import React, { useState, useEffect, useCallback } from 'react';
import { getJobGroups } from '../../../services/apiService';
// import DoneIcon from '@material-ui/icons/Done';
// import LoadingCircleIcon from '../../icons/LoadingCircle';
import { useHistory } from 'react-router-dom';
import JobGroupsTable from '../_utils/table';
import { Dropdown } from 'semantic-ui-react';
import useFilterPlacementSpoc from '../_utils/useFilterPlacementSpoc';
import usePaginationState from '../_utils/usePaginationState';
import CustomPagination from '../_components/CustomPagination';
import { debounce } from 'lodash';
import { useSelector } from 'react-redux';

// enum for job group status
// const GROUP_STATUS = {
//   ALL: 'All',
//   OPEN: 'Active',
//   CLOSED: 'Closed',
//   ON_HOLD: 'On Hold',
// };

// const sortColumnOptions = [
//   { key: 'createdAt', value: 'createdAt', text: 'Creation Date' },
//   { key: 'lastGroupActivity', value: 'lastGroupActivity', text: 'Last activity' },
//   { key: 'highestProgressLevel', value: 'highestProgressLevel', text: 'Students' },
// ];
function JobDashboard() {
  const history = useHistory();
  const [data, setData] = useState([]);

  const [filter, setFilter] = useState('all');
  // const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
  const [sortColumn, setSortColumn] = useState('createdAt');
  const [sortType, setSortType] = useState('DESC');
  const {
    loading,
    placementSpocOptions,
    placementSpocFilter,
    setPlacementSpocFilter,
  } = useFilterPlacementSpoc();
  const { page, setPage, size, setSize, totalCount, setTotalCount } =
    usePaginationState();

  // Get logged in user from Redux store
  const loggedInUser = useSelector((state) => {
    console.log('Redux State:', state); // Debug log
    return state?.userReducer?.user;
  });

  // const [dialogOpen, setDialogOpen] = useState(false);
  // const [loading, setLoading] = useState(false);

  // Set default placement spoc filter to logged in user
  useEffect(() => {
    console.log('Logged in user:', loggedInUser); // Debug log
    console.log('Placement spoc options:', placementSpocOptions); // Debug log 
    
    if (loggedInUser?.id && placementSpocOptions.length > 0) {
      console.log('Setting default filter to:', loggedInUser.id); // Debug log
      setPlacementSpocFilter([loggedInUser.id]);
    }
  }, [loggedInUser, placementSpocOptions, setPlacementSpocFilter]);

  const fetchJobGroups = useCallback(async () => {
    try {
      // setLoading(true);
      const statusFilter =
        filter === 'active' || filter === 'inactive'
          ? { activeStatus: filter === 'active' }
          : { status: filter };
      const response = await getJobGroups({
        page,
        size,
        companyNameSearchString: debouncedSearchQuery,
        placementSpocIds: placementSpocFilter,
        statusFilter,
        sortParams: {
          sortColumn: sortColumn,
          sortType,
        },
      });
      // setLoading(false);
      if (response) {
        setData(response.data);
        setTotalCount(response.totalCount);
      }
    } catch (error) {
      // setLoading(false);
      console.log(error);
    }
  }, [
    page,
    size,
    placementSpocFilter,
    debouncedSearchQuery,
    filter,
    sortType,
    sortColumn,
  ]);

  // fetch job groups on component mount
  useEffect(() => {
    if (!loading) fetchJobGroups();
  }, [fetchJobGroups, loading]);

  // filter the data by the filter value everytime the filter value or job groups data changes
  // useEffect(() => {
  //   // if (data.length > 0) {
  //   // filterJobGroups();
  //   // }
  // }, [data]);

  useEffect(() => {
    const debouncedQuery = debounce(() => {
      setDebouncedSearchQuery(searchQuery);
      setPage(0);
    }, 500);
    debouncedQuery();
    return () => debouncedQuery.cancel();
  }, [searchQuery]);

  // useEffect(() => {
  //   if (placementSpocFilter) {
  //     filterJobGroupsByPlacementSpoc();
  //   }
  // }, [placementSpocFilter]);

  // const filterJobGroupsByPlacementSpoc = () => {
  //   if (placementSpocFilter.length !== 0) {
  //     return setFilteredData(
  //       data.filter((group) =>
  //         placementSpocFilter?.includes(group?.placementSpocId)
  //       )
  //     );
  //   }
  //   fetchJobGroups();
  // };

  // const filterJobGroups = () => {
  //   // if (filter === GROUP_STATUS.ALL) {
  //   //   setFilteredData(data);
  //   // } else if (filter === GROUP_STATUS.OPEN) {
  //   //   setFilteredData(data.filter((group) => group.status === 'open'));
  //   // } else if (filter === GROUP_STATUS.CLOSED) {
  //   //   setFilteredData(data.filter((group) => group.status !== 'open'));
  //   // } else if (filter === GROUP_STATUS.ON_HOLD) {
  //   //   setFilteredData(data.filter((group) => group.status === 'on_hold'));
  //   // }

  //   // filter using search query
  //   // if (searchQuery) {
  //   //   setFilteredData(
  //   //     filteredData.filter((group) =>
  //   //       group.companyDetails.companyName
  //   //         .toLowerCase()
  //   //         .includes(searchQuery.toLowerCase())
  //   //     )
  //   //   );
  //   // }
  // };

  const renderJobGroups = () => {
    // if (showCreateGroupForm && !showAddStudentsForm) {
    //   return (
    //     <CreateJobGroup toggleShowCreateGroup={toggleShowCreateGroupForm} toggleShowAddStudents={toggleShowAddStudentsForm}/>
    //   );
    // }
    // if (showAddStudentsForm ) {
    //   return <AddStudents toggleShowAddStudents={toggleShowAddStudentsForm} />;
    // }

    return (
      <div>
        <div className='flex items-center justify-between'>
          <h1 className='my-5 text-3xl font-semibold user-heading'>
            Job Groups
          </h1>
          <button
            onClick={() => {
              history.push(`/job-dashboardv2/create-job-group`);
            }}
            className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
          >
            Create Job Group
          </button>
        </div>
        <div className='flex items-center justify-between mb-6 mt-9'>
          <div className='px-6 bg-white border border-gray-300 rounded'>
            <select
              onChange={({ target }) => {
                setPage(0);
                setFilter(target.value);
              }}
              value={filter}
              className='cursor-pointer focus:outline-none'
            >
              <option value='all'>All</option>
              <option value='open'>Open</option>
              <option value='closed'>Closed</option>
              <option value='active'>Active</option>
              <option value='inactive'>In-Active</option>
              {/* <option value='On Hold'>On Hold</option> */}
            </select>
          </div>
          <div className='flex items-center justify-end gap-4'>
            <form
              className='flex items-center'
              onSubmit={(e) => {
                e.preventDefault();
              }}
            >
              <label htmlFor='simple-search' className='sr-only'>
                Search by name
              </label>
              <div className='relative w-full'>
                <div className='absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none'>
                  <svg
                    aria-hidden='true'
                    className='w-5 h-5 text-gray-500 dark:text-gray-400'
                    fill='currentColor'
                    viewBox='0 0 20 20'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      fillRule='evenodd'
                      d='M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z'
                      clipRule='evenodd'
                    />
                  </svg>
                </div>
                <input
                  type='text'
                  id='simple-search'
                  className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                  placeholder='Search by name'
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
            </form>
            {placementSpocOptions.length > 0 && (
              <Dropdown
                placeholder='Placement Spoc'
                options={placementSpocOptions}
                search
                multiple
                selection
                value={placementSpocFilter}
                onChange={(e, { value }) => {
                  setPage(0);
                  setPlacementSpocFilter(value);
                }}
              />
            )}
          </div>
        </div>

        <JobGroupsTable
          rowData={data}
          setSortType={setSortType}
          setSortColumn={setSortColumn}
        />
        <CustomPagination
          totalCount={totalCount}
          page={page}
          setPage={setPage}
          size={size}
          setSize={setSize}
        />
      </div>
    );
  };

  return <div>{renderJobGroups()}</div>;
}

export default JobDashboard;
